/**
 * 라우트 상수 정의
 */

// 공개 라우트
export const PUBLIC_ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  REGISTER_TERMS: '/register/terms',
  REGISTER_FORM: '/register/form',
  REGISTER_COMPLETE: '/register/complete',
  FIND_ID: '/find-id',
  FIND_ID_RESULT: '/find-id/result',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_NEW: '/reset-password/new',
  RESET_PASSWORD_COMPLETE: '/reset-password/complete',
} as const;

// 보호된 라우트 - 일반 사용자
export const PROTECTED_ROUTES = {
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  BOOK_LIST: '/book/list',
  BOOK_VIEWER: '/book/viewer/:pageNumber',
  API_BOOK_VIEWER: '/api-book/viewer/:bookUid/:pageIndex',
  INQUIRY: '/inquiry',
  INQUIRY_CREATE: '/inquiry/create',
  INQUIRY_EDIT: '/inquiry/edit/:ticketNo',
} as const;

// 보호된 라우트 - 관리자
export const ADMIN_ROUTES = {
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_USERS: '/admin/users',
} as const;

// 공통 라우트
export const COMMON_ROUTES = {
  HOME: '/',
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND: '/404',
} as const;

// 모든 라우트
export const ALL_ROUTES = {
  ...PUBLIC_ROUTES,
  ...PROTECTED_ROUTES,
  ...ADMIN_ROUTES,
  ...COMMON_ROUTES,
} as const;

// 라우트 타입
export type PublicRoute = typeof PUBLIC_ROUTES[keyof typeof PUBLIC_ROUTES];
export type ProtectedRoute = typeof PROTECTED_ROUTES[keyof typeof PROTECTED_ROUTES];
export type AdminRoute = typeof ADMIN_ROUTES[keyof typeof ADMIN_ROUTES];
export type CommonRoute = typeof COMMON_ROUTES[keyof typeof COMMON_ROUTES];
export type AllRoute = typeof ALL_ROUTES[keyof typeof ALL_ROUTES];
